import { render } from "./batchDeliveryGroup.vue?vue&type=template&id=55b6a706&scoped=true"
import script from "./batchDeliveryGroup.vue?vue&type=script&lang=js"
export * from "./batchDeliveryGroup.vue?vue&type=script&lang=js"

import "./batchDeliveryGroup.vue?vue&type=style&index=0&id=55b6a706&lang=css"
import "./batchDeliveryGroup.vue?vue&type=style&index=1&id=55b6a706&scoped=true&lang=css"

import exportComponent from "D:\\AAA_WORK\\os_FMS_sys_projectop\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55b6a706"]])

export default __exports__